/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* HC connecting images with the selected variant 21 Oct '20 */
  const colorSwatches = document.querySelectorAll(".ColorSwatchList li");
  const mainImages = document.querySelectorAll(".Product__Slideshow .Product__SlideItem");
  const thumbImages = document.querySelectorAll(".Product__SlideshowNavScroller a");
  const verifyTemplate = document.querySelector('#shopify-section-product-template .Product');
  //Functions
  const initFlickity = () => {
    let config = {
      pageDots: true,
      contain: true,
      imagesLoaded: true,
      cellAlign: "left",
      cellSelector: ".Product__SlideItem--image",
      prevNextButtons: false,
      watchCSS: true,
      dragThreshold: 8,
    };
    flkty = new Flickity(".Product__Slideshow", config);
  };
  const showImage = (id) => { mainImages.forEach( image =>{ image.dataset.hide = image.dataset.mediaId === id?"false":"true" })}
  
  const hideDesktop = (value) => {
    let activeImages = [];
    
    /* HC - Filtering adjustment - 30 Dec '20 */
    thumbImages.forEach((image,i) => {
      if(typeof image.dataset.imageAlt !== 'undefined'){
        image.style.display = image.dataset.imageAlt == value || image.dataset.imageAlt.indexOf('all') != -1 ? "block" : "none"; 
      }   
      if(window.getComputedStyle(image).display === 'block'){
        activeImages.push(image)
      }
      image.addEventListener('click', () => {
         showImage(image.dataset.mediaId)                     
      })
    });
    showImage(activeImages[0].dataset.mediaId)
  };
  const hideMobile = (value) => {
    mainImages.forEach((image) => {
      
      if (image.dataset.imageAlt !== value) {
        image.dataset.hide = true;
       image.classList.remove("Product__SlideItem--image");
      } else {
        image.dataset.hide = false;
         image.classList.add("Product__SlideItem--image");
      }
    });
    let activeImages = [];
    thumbImages.forEach((image,i) => {
      image.style.display = image.dataset.imageAlt !== value ? "none" : "block"; 
      if(window.getComputedStyle(image).display === 'block'){
        activeImages.push(image)
      }
      image.addEventListener('click', () => {
         showImage(image.dataset.mediaId)                     
      })
    });
    showImage(activeImages[0].dataset.mediaId)
    flkty.destroy();
    initFlickity();
  };
  const initFilterDesktop = () => {
    colorSwatches.forEach((swatch) => {
      let inputRadio = swatch.querySelector('input[type="radio"]');
      if (inputRadio.checked) {
        hideDesktop(inputRadio.value);
      }
      swatch.addEventListener("click", () => {
        let inputRadio = swatch.querySelector('input[type="radio"]');
        hideDesktop(inputRadio.value);
      });
    });
  };
  const initFilterMobile = () => {
    initFlickity();
    colorSwatches.forEach((swatch) => {
      let inputRadio = swatch.querySelector('input[type="radio"]');
      if (inputRadio.checked) {
        hideMobile(inputRadio.value);
      }
      swatch.addEventListener("click", () => {
        let inputRadio = swatch.querySelector('input[type="radio"]');
        hideMobile(inputRadio.value);
      });
    });
  };
  const checkDevice = (device) => {
    (device.matches) ? initFilterDesktop() : initFilterMobile();
  };
  if(verifyTemplate.dataset.template.includes('alternate')){
      const device = window.matchMedia("(min-width: 1008px)");
      checkDevice(device);
      device.addListener(checkDevice);
  }
  
/* HC - mobile thumbnails - 28 Oct '20 */
function mobileThumbnailsHC(){
  if(window.innerWidth < 1008){
    document.querySelector('.Product__SlideshowNav--thumbnails').style.top = document.querySelector('.Product__Slideshow').offsetHeight + 10 + 'px';
   
    let allThumbnails = document.querySelectorAll('.Product__SlideshowNavScroller a');
    for(let i=0; i<allThumbnails.length;i++){
      allThumbnails[i].addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();   
        
        for(let j=0; j<allThumbnails.length;j++){
          allThumbnails[j].classList.remove('is-selected');
        }
        
        allThumbnails[i].classList.add('is-selected');
        let allDots = document.querySelectorAll('.Product__SlideshowMobileNav .flickity-page-dots button');
        allDots[i].dispatchEvent(new Event('click', { 'bubbles': true }));
      });
    }
  }
}
window.addEventListener('DOMContentLoaded', function(){
  mobileThumbnailsHC();
});

window.onresize = mobileThumbnailsHC;



